// Product Card Image Navigation
document.addEventListener('DOMContentLoaded', function() {
  // Find all product cards with swipeable media
  const productCards = document.querySelectorAll('.product-card');
  
  productCards.forEach(productCard => {
    const mediaContainer = productCard.querySelector('.product-card__media--swipeable');
    const prevButton = productCard.querySelector('.product-card__nav-arrow--prev');
    const nextButton = productCard.querySelector('.product-card__nav-arrow--next');
    const images = mediaContainer?.querySelectorAll('img');
    
    if (!mediaContainer || !prevButton || !nextButton || !images || images.length <= 1) return;
    
    let currentIndex = 0;
    const maxIndex = images.length - 1;
    
    // Initialize button states
    updateButtonStates();
    
    // Previous button click
    prevButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      goToPrevious();
    });

    // Next button click
    nextButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      goToNext();
    });

    // Keyboard navigation
    mediaContainer.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goToPrevious();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        goToNext();
      }
    });

    // Scroll event to update current index
    mediaContainer.addEventListener('scroll', () => {
      updateCurrentIndex();
      updateButtonStates();
    });

    function goToPrevious() {
      if (currentIndex > 0) {
        currentIndex--;
        scrollToImage(currentIndex);
      }
    }

    function goToNext() {
      if (currentIndex < maxIndex) {
        currentIndex++;
        scrollToImage(currentIndex);
      }
    }

    function scrollToImage(index) {
      if (images[index]) {
        const imageWidth = images[0].offsetWidth;
        const scrollPosition = index * imageWidth;
        mediaContainer.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });
      }
    }

    function updateCurrentIndex() {
      const scrollLeft = mediaContainer.scrollLeft;
      const imageWidth = images[0]?.offsetWidth || 0;
      currentIndex = Math.round(scrollLeft / imageWidth);
    }

    function updateButtonStates() {
      // Update previous button
      prevButton.disabled = currentIndex === 0;
      prevButton.style.opacity = currentIndex === 0 ? '0.5' : '1';
      
      // Update next button
      nextButton.disabled = currentIndex === maxIndex;
      nextButton.style.opacity = currentIndex === maxIndex ? '0.5' : '1';
    }
  });
});
